import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.flat-map.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "mb-3 flex items-center gap-4"
};
const _hoisted_2 = {
  class: "text-sm font-medium text-slate-700"
};
const _hoisted_3 = ["disabled"];
import { ref } from 'vue';
import { ElMessage } from 'element-plus';
import { updateFolderAcl } from '@/api/assets';
import AssetFolderAclEditor from './AssetFolderAclEditor.vue';
export default {
  __name: 'AssetFolderAclDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    folderId: {
      type: [Number, String],
      default: null
    },
    folderName: {
      type: String,
      default: ''
    },
    folder: {
      type: Object,
      default: null
    }
  },
  emits: ['update:visible', 'success'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const loading = ref(false);
    const saving = ref(false);
    const visibilityType = ref('INHERIT');
    const aclItems = ref([]);
    async function fetchAcl() {
      if (!props.folderId) return;
      loading.value = true;
      try {
        const data = props.folder || {};
        visibilityType.value = data.visibilityType || 'INHERIT';
        const aclList = data.aclItems || data.aclList || [];
        aclItems.value = aclList.filter(item => item.subjectType !== 'ROLE').map(item => ({
          subjectType: item.subjectType || 'USER',
          subjectValue: item.subjectType === 'ALL_AUTHENTICATED' ? [] : [item.subjectId],
          permissionLevel: item.permissionLevel || 'VIEW'
        }));
      } catch {
        // handled by interceptor
      } finally {
        loading.value = false;
      }
    }
    function normalizeSubjectIds(item) {
      if (item.subjectType === 'ALL_AUTHENTICATED') return 0;
      const value = item.subjectValue;
      const values = Array.isArray(value) ? value : [value];
      return values.map(subject => {
        if (subject && typeof subject === 'object') return Number(subject.id) || 0;
        return Number(subject) || 0;
      }).filter(Boolean);
    }
    function expandAclItems() {
      return aclItems.value.flatMap(item => {
        if (item.subjectType === 'ALL_AUTHENTICATED') {
          return [{
            subjectType: item.subjectType,
            subjectId: normalizeSubjectIds(item),
            permissionLevel: item.permissionLevel
          }];
        }
        return normalizeSubjectIds(item).map(subjectId => ({
          subjectType: item.subjectType,
          subjectId,
          permissionLevel: item.permissionLevel
        }));
      });
    }
    async function handleSave() {
      saving.value = true;
      try {
        const body = {
          visibilityType: visibilityType.value,
          aclList: visibilityType.value === 'CUSTOM' ? expandAclItems() : []
        };
        await updateFolderAcl(props.folderId, body);
        ElMessage.success('权限配置已保存');
        emit('success');
        emit('update:visible', false);
      } catch {
        // handled by interceptor
      } finally {
        saving.value = false;
      }
    }
    return (_ctx, _cache) => {
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_dialog, {
        "model-value": __props.visible,
        title: "文件夹权限配置",
        width: "760px",
        style: {
          "max-width": "92vw"
        },
        "close-on-click-modal": false,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.$emit('update:visible', $event)),
        onOpen: fetchAcl
      }, {
        footer: _withCtx(() => [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          onClick: _cache[2] || (_cache[2] = $event => _ctx.$emit('update:visible', false))
        }, "取消"), _createElementVNode("button", {
          type: "button",
          class: "btn-primary",
          disabled: saving.value,
          onClick: handleSave
        }, _toDisplayString(saving.value ? '保存中...' : '保存'), 9, _hoisted_3)]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_cache[4] || (_cache[4] = _createElementVNode("span", {
          class: "text-sm text-slate-500"
        }, "文件夹：", -1)), _createElementVNode("span", _hoisted_2, _toDisplayString(__props.folderName), 1)]), _createVNode(AssetFolderAclEditor, {
          "visibility-type": visibilityType.value,
          "onUpdate:visibilityType": _cache[0] || (_cache[0] = $event => visibilityType.value = $event),
          "acl-items": aclItems.value,
          "onUpdate:aclItems": _cache[1] || (_cache[1] = $event => aclItems.value = $event)
        }, null, 8, ["visibility-type", "acl-items"])])), [[_directive_loading, loading.value]])]),
        _: 1
      }, 8, ["model-value"]);
    };
  }
};